/*************************
 * Author : Matthieu ROBIN
 *************************/

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  createStyles,
  Skeleton,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import React, { FunctionComponent } from "react";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: "flex",
      height: 150,
    },
    content: {
      flex: "1 0 auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    image: {
      minWidth: 150,
      minHeight: "100%",
    },
    detail: {
      display: "flex",
      alignItems: "center",
    },
  })
);

const CarCardSkeleton: FunctionComponent = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader
        avatar={
          <Skeleton
            animation="wave"
            variant="circular"
            width={30}
            height={30}
          />
        }
        title={
          <Skeleton
            animation="wave"
            height={15}
            width="80%"
            style={{ marginBottom: 6 }}
          />
        }
        subheader={<Skeleton animation="wave" height={15} width="40%" />}
      />
      <Skeleton sx={{ height: 200 }} animation="wave" variant="rectangular" />
      <CardContent>
        <Stack spacing={1}>
          <Stack direction="row" spacing={1}>
            <Skeleton
              animation="wave"
              height={15}
              width="80%"
              style={{ marginBottom: 6 }}
            />
          </Stack>
          <Stack direction="row" spacing={1}>
            <Skeleton
              animation="wave"
              height={15}
              width="40%"
              style={{ marginBottom: 6 }}
            />
          </Stack>
          <Box>
            <Skeleton
              sx={{ height: 15, width: 60 }}
              animation="wave"
              variant="rounded"
            />
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CarCardSkeleton;
